import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
import getJsonLD, { TYPES } from '~/helpers/json-ld';
const getCategoryJsonLD = getJsonLD(TYPES.CATEGORY);
export default {
  name: 'CategoryJsonLD',
  props: {
    category: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    scriptJsonLD() {
      const category = _objectSpread({}, this.category, {
        url: this.url
      });

      return {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(getCategoryJsonLD(category, this.locale)),
        body: true
      };
    }

  }),

  head() {
    return {
      script: [this.scriptJsonLD]
    };
  },

  render: h => h(null)
};